"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var MB = Math.pow(1024, 2);
var MAX_NUM_ATTACHMENTS = 100;
var MAX_ATTACHMENT_SIZE = 10 * MB;
var totalSizeError = {
  key: 'customerDataEmail.Attachments.errors.totalSize',
  options: {
    max: MAX_ATTACHMENT_SIZE / MB
  }
};
var maxNumError = {
  key: 'customerDataEmail.Attachments.errors.maxNum',
  options: {
    max: MAX_NUM_ATTACHMENTS
  }
};

var totalSize = function totalSize(attachments) {
  return attachments.reduce(function (total, attachment) {
    return total + attachment.get('size');
  }, 0);
};

var validateAll = function validateAll(attachments) {
  var errors = (0, _immutable.List)();
  var size = totalSize(attachments);

  if (size > MAX_ATTACHMENT_SIZE) {
    var total = (size / MB).toFixed(2);
    var options = Object.assign({
      total: total
    }, totalSizeError.options);
    errors = errors.push(Object.assign({}, totalSizeError, {
      options: options
    }));
  }

  if (attachments.size > MAX_NUM_ATTACHMENTS) {
    errors = errors.push(maxNumError);
  }

  return errors;
};

var EmailAttachmentValidators = {
  file: function file() {
    return false;
  },
  all: function all(attachments) {
    return validateAll(attachments);
  }
};
var _default = EmailAttachmentValidators;
exports.default = _default;
module.exports = exports.default;